import React, { useEffect, useState } from "react";
import ProductCard from "../Component/ProductCard";
import axios from "axios";
import { DealerApi } from "../Component/Api";
import "./Home.css";
import Cookies from "js-cookie";
import CategoryComponent from "../Component/CategoryComponent";
import advertisement from "../Images/dealer-town-logo.jpg";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";
import { Toast } from "react-bootstrap";

const Home = ({setting}) => {
  const [featured, setFeatured] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const token = Cookies.get("loginToken");
  const tokenObject = token && JSON.parse(token);
  const [load, setLoad] = useState(true);
  const [boxesData, setBoxesData] = useState([]);

  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");

  document.title =
    "THE DEALER :: thedealer.ie :: buy, sell, exchange online in Ireland, Northern Ireland";

  useEffect(() => {
    setLoad(true);
    axios
      .get(`${DealerApi}/listing/featured`)
      .then((res) => {
        setLoad(false);
        // console.log("Featured",res.data.body.result)
        setFeatured(res.data.body.result);
      })
      .catch((err) => {
        setLoad(false);
      });
  }, []);

  const wishListFunction = async () => {
    if (tokenObject) {
      await axios
        .get(`${DealerApi}/wishlist/${tokenObject.id}`)
        .then((res) => {
          setWishlist(res.data.body.result.data);
        })
        .catch((err) => {});
    }
  };

  useEffect(() => {
    wishListFunction();
  }, [load]);

  const isInWishlist = (itemId) => {
    return wishlist && wishlist.some((item) => item.id === itemId);
  };

  const updateWishlist = () => {
    wishListFunction();
  };

  const handleStatus = (status) => {
    setShowModal(status);
  };

  useEffect(() => {
    // Check if screen width is less than or equal to 500px
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500);
    };

    handleResize(); // Check on initial render

    window.addEventListener("resize", handleResize); // Listen for resize events

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up on component unmount
    };
  }, []);

  useEffect(() => {
    if (isMobile && showModal) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling
    }
  }, [isMobile, showModal]);

  useEffect(() => {
    // setLoad(true);
    fetch(`${DealerApi}/category`)
      .then((response) => response.json())
      .then((data) => {
        // setLoad(false);
        setBoxesData(data.body.result);
      })
      .catch((error) => {
        // setLoad(false);
      });
  }, []);

  const showToast = (message, type = "") => {
    setToastType(type);
    setToastMessage(message);

    setTimeout(() => {
      setToastMessage("");
    }, 5000);
  };

  return (
    <>
    <Helmet>
        <title>THE DEALER :: thedealer.ie :: buy, sell, exchange online in Ireland, Northern Ireland</title>
        <meta
          name="description"
          content={`${setting.meta_description}`}
        />
        <meta
          name="keywords"
          content={`${setting.meta_keywords}`}
        />
    </Helmet>
      {isMobile && showModal && <div className="overlay" id="overlay"></div>}
      <div className="home_main_div">
        <div className="home_category_section">
          <div className="category_section container">
            <div className="category_content">
              <div className="grid-container">
                <CategoryComponent status={handleStatus} boxesData={boxesData}/>
              </div>

              <div className="place_add">
                <a href="mailto:sales@thedealer.ie">
                  <img
                    src={advertisement}
                    alt="logo"
                    className="advertisement_img_p"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="load_img_div">
          {load && <FontAwesomeIcon icon={faSpinner} spin className="loader_img" />}
          </div>
          {featured && featured.length > 0 && (
            <div className="grid_section">
              <Toast
                show={toastMessage !== ""}
                onClose={() => setToastMessage("")}
                className={`fade toast_message_div ${
                  toastType === "success" ? "bg-success" : "bg-danger"
                }`}
              >
                <Toast.Body className="toast_message text-white">
                  {toastMessage}
                </Toast.Body>
              </Toast>
              <h2 className="featured_heading">Featured Listings</h2>
              <div className="featured_line"></div>
              <div className="product_grid">
                {featured.map((product) => {
                  return (
                    <ProductCard
                      key={product.id}
                      product={product}
                      wishlist={wishlist}
                      isInWishlist={isInWishlist(product.id)}
                      updateWishlist={updateWishlist}
                      showToast={showToast}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Home;